export default Object.freeze({
  ORGANIZATION: "Digital Cow Software, Inc.",

  APP: "Moo've",
  FULLNAME: "Digital Cow Software",
  COMPANY: "DCS",
  DESCRIPTION: "A general workout tracker",
})